import { render, staticRenderFns } from "./CarriageEdit.vue?vue&type=template&id=7de5a1ce&"
import script from "./CarriageEdit.vue?vue&type=script&lang=js&"
export * from "./CarriageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports